module.exports = __webpack_public_path__ + "assets/img/logo-jw-3cab8dfc.png";